export const LIVE_PAGE_SUBTYPE = 'live';
